import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
// import { Setting } from '../../providers/setting';

@Injectable()
export class AuthenticationGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('UserToken') !== null) {
            return true;
        } else {
            this.router.navigate(['LoginComponent']);
            return false;
        }
    }
}
